module.exports = __webpack_public_path__ + "img/menu-acacia.aef87c2b.jpg";